import { PermissionResource } from '@entities/client/permission';

import { requirePermission } from '../../../require-permission';

export const ordersLoader = requirePermission(PermissionResource.ClientFuelOrderCoupons);
